module.exports = "<div ng-if=\"ctrl.isAdjusted\" class=\"row ut-receipt-adjustmentAlert\">\n    <div class = \"col-12 mt-3 text-center\">\n        <div class=\"p-1 h4 mb-0 notification_bar notification_bar_top_text bar-header_title\">\n            ORDER ADJUSTMENT\n        </div>\n        <div class=\"p-1 h5 mb-0 notification_bar notification_bar_bottom_text border-top-0\">\n            See order below for details\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/receipt/sections/adjustmentBar.html
// module id = 755
// module chunks = 0